import React from 'react';
import { EmptySearchResult } from '@shopify/polaris';
import { t } from 'react-simple-multi-language';

const TableEmptyState = () => {
  return <EmptySearchResult title={t('order_not_found')} withIllustration />;
};

export default TableEmptyState;
